<div [ngClass]="['cell', resourcesCssService.responsiveClass()]">
  <div class='badge' (click)='gotoTraining()'>
    <button><i class='mt-link'></i></button>
  </div>
  <div class='info'>
    <h2 class='title' (click)='gotoTraining()'>{{ training.name }}</h2>
    <div ></div>
    <p class='description' [hidden]='!training.content' [innerHTML]="trainingContent"></p>
  </div>
</div>